import root from 'window-or-global';

export const addEventListener = (eventType, callback) => root.addEventListener(eventType, callback);

export const removeEventListener = (eventType, callback) =>
  root.removeEventListener(eventType, callback);
